import { Stack } from "@chakra-ui/react"

export const FormFieldsStack = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return <Stack spacing={6}>{children}</Stack>
}
